import { Controller } from '@hotwired/stimulus';

import { repeated } from '@/modules/mask';

export default class extends Controller {
  connect() {
    const { maxlength, minlength } = this.element.attributes;
    const max = Number(maxlength?.value || 140);
    const min = Number(minlength?.value || 1);

    repeated(this.element, { definitions: { N: /[a-zA-Z0-9\s]/ } }, 'N', min, max);
  }
}
